import { useLocales } from "@/locales";
import { CommonWrap } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box, Link } from "@mui/material";
import { Trans } from "react-i18next";
import { TELEGRAM_SUPPORT_URL } from "@/config";

export default function PaymentAccessProcess() {
  const { translate } = useLocales();
  return (
    <ContentWrap
      leftChildren={
        <CommonWrap>
          <>
            <Box component={"div"} className="title_0" id="api-flow-diagram">
              {translate("faq.payment_access_process_title")}
            </Box>
            <Trans
              i18nKey={"faq.payment_access_process_desc"}
              t={translate as any}
            >
              Just a placeholder
              <Link
                href={TELEGRAM_SUPPORT_URL}
                target="_blank"
                className="link"
                underline="always"
              >
                Just a placeholder
              </Link>
            </Trans>
          </>
        </CommonWrap>
      }
    />
  );
}
